<div class="heading" *ngIf="groups.includes('admin') || groups.includes('operation')">
    <div class="button-wrapper">
      <div class="valet-drop-down">
        <select [(ngModel)]="selectedExpertId" (ngModelChange)="handleExpertChange($event)">
          <option [ngValue]="null" disabled selected>Select Valet</option>
          <option *ngFor="let expert of experts" [ngValue]="expert.id">{{ expert.user.surname }} {{ expert.user.name }}</option>
        </select>
      </div>
      <div class="valet-name">
        <span *ngIf="selectedExpertId">
          {{ selectedExpert?.user?.surname?.toUpperCase() }} {{ selectedExpert?.user?.name?.toUpperCase() }}
        </span>
      </div>
      <div class="valet-wallet">
        <span *ngIf="selectedExpertId">
          <i class="fas fa-wallet"></i>
          {{ totalCreditAmount | currency:'EUR' }}
        </span>
      </div>
    </div>
</div>

<section class="main-content wrapper content-padding">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
    <div class="table-responsive-invoice has-margin-top" style="overflow-x: scroll; ">
        <div class="custom-data-output has-margin-top" role="table" id="elencoConsegneAdmin">
            <form class="table-row-container row first-row filter" [formGroup]="transactionFilterForm" (ngSubmit)="filter()" *ngIf="transactionFilterForm">

                <div class="item data-col-5">
                    <h4 class="title" (click)="navigateOrder('Transactions.id')">
                        <i class="sort-icon fas " [ngClass]="orderIcon('Transactions.id')"></i>
                        ID
                    </h4>
                    <span class="data">
                        <input type="number" formControlName="Transactions.id" min="1000" max="10000">
                    </span>
                </div>

                <div class="item data-col-5">
                    <h4 class="title" (click)="navigateOrder('Delivery.id')">
                        <i class="sort-icon fas " [ngClass]="orderIcon('Delivery.id')"></i>
                        DELIVERY ID
                    </h4>
                    <span class="data">
                        <input type="number" formControlName="Delivery.id" min="1000" max="10000">
                    </span>
                </div>
                                
                <div class="item data-col-10">
                    <h4 class="title">PAYMENT STATO</h4>
                    <span class="data">
                        <select formControlName="Transactions.transactionPaymentStatus">
                            <option value="">Tutti</option>
                            <ng-container *ngFor="let paymentStatus of deliveryPaymentStatusAux['mixed']">
                                <option *ngIf="paymentStatus !== 'default'" [value]="paymentStatus">
                                {{ deliveryPaymentStatusAux.ln('it', paymentStatus) }}
                                </option>
                            </ng-container>
                        </select>
                    </span>
                </div>

                <div class="item data-col-10">
                    <h4 class="title" (click)="navigateOrder('Transactions.transactionId')">
                        <i class="sort-icon fas " [ngClass]="orderIcon('Transactions.transactionId')"></i>
                        TRANSAZIONI ID
                    </h4>
                    <span class="data">
                        <input type="number" formControlName="Transactions.transactionId" min="1000" max="10000">
                    </span>
                </div>
        
                <div class="item center data-col-10">
                    <h4 class="title" (click)="navigateOrder('Transactions.creditAt')">
                        <i class="sort-icon fas" [ngClass]="orderIcon('Transactions.creditAt')"></i>
                        CREDITO DATA
                    </h4>
                    <span class="data">
                        <div class="date">Da: </div>
                        <input class="date" type="date" formControlName="Transactions.creditAt_From">
                    </span>
                    <span class="data">
                        <div class="date">A: </div>
                        <input class="date" type="date" formControlName="Transactions.creditAt_To">
                    </span>
                </div>
        
                <div class="item center data-col-10">
                    <h4 class="title" (click)="navigateOrder('Transactions.debitAt')">
                        <i class="sort-icon fas" [ngClass]="orderIcon('Transactions.debitAt')"></i>
                        ADDEBITO DATA
                    </h4>
                    <span class="data">
                        <div class="date">Da: </div>
                        <input class="date" type="date" formControlName="Transactions.debitAt_From">
                    </span>
                    <span class="data">
                        <div class="date">A: </div>
                        <input class="date" type="date" formControlName="Transactions.debitAt_To">
                    </span>
                </div>
        
                <!-- 
                <div class="item data-col-15" *ngIf="groupWhitelisted('admin')">
                    <h4 class="title" (click)="navigateOrder(['Transactions.id'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['Transactions.id'])"></i>
                        VALET
                    </h4>
                    <span class="data"> 
                        <input type="text" formControlName="Transactions.id">
                    </span>
                </div> 
                -->

                <div class="item data-col-10" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                    <h4 class="title" (click)="navigateOrder(['Transactions.totalAmount'])">
                        <i class="sort-icon fas" [ngClass]="orderIcon(['Transactions.totalAmount'])"></i>
                        TOTALE</h4>
                    <span class="data">
                        <select formControlName="Transactions.totalAmount.operator" style="width: 40px;">
                            <option value="equal">=</option>
                            <option value="lessThan"><</option>
                            <option value="moreThan">></option>
                            <option value="moreThanOrEqual">>=</option>
                            <option value="lessThanOrEqual"><=</option>
                        </select>
                        <input type="text" formControlName="Transactions.totalAmount" style="width: 100%;">
                    </span>
                </div>
      
                <div class="item nowrap">
                    <h4 class="title hide-on-mobile">AZIONI</h4>
                    <span class="data-row-left btn-container">
                    <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                        RICERCA <i class="fas fa-search"></i></button>
                        <br/>
                    <button class="btn vertical align-items-center" (click)="fnReset();">
                        RESET <i class="fas fa-times-circle"></i></button>
                    </span>
                </div>
            </form>

            <div class="table-row-container row" *ngFor="let transaction of transactions">

                <div class="data-id item data-col-5">
                  <span class="data-row-left">
                    <h4 class="title table-title">ID :</h4>
                    <a>
                      #{{ transaction.id }}
                    </a>
                  </span>
                </div>    

                <div class="data-id item data-col-5">
                  <span class="data-row-left">
                    <h4 class="title table-title">DELIVERY ID :</h4>
                    <a>
                      #{{ transaction.delivery.id }}
                    </a>
                  </span>
                </div>    

                <div class="item data-col-10">
                  <span class="data-row-left">
                    <h4 class="title table-title">PAYMENT STATO :</h4>
                    <a class="badge">
                      <mat-chip [matTooltip]="showFinancialStatus(transaction)" class="chip" [class]="transactionStatusClass(transaction)">{{ showFinancialStatus(transaction) }}</mat-chip>
                    </a>
                  </span>
                </div>

                <div class="item data-col-10">
                  <span class="data-row-left">
                    <h4 class="title table-title">TRANSAZIONI ID :</h4>
                    <a>
                      {{ transaction.transactionId || "---" }}
                    </a>
                  </span>
                </div>      
      
                <div class="item center data-col-10">
                  <span class="data-row-left">
                    <h4 class="title table-title dataGesture">CREDITO DATA :</h4>
                    <a>
                      {{ (transaction.createdAt | date:'fullDate' | titlecase) }}
                    </a>
                  </span>
                </div>
      
                <div class="item center data-col-10">
                  <span class="data-row-left">
                    <h4 class="title table-title dataGesture">ADDEBITO DATA :</h4>
                    <a>
                      {{ (transaction.debitdAt ? (transaction.debitdAt | date:'fullDate' | titlecase) : "---") }}
                    </a>
                  </span>
                </div>
      
                <!--
                <div class="item data-col-15" *ngIf="groupWhitelisted('admin')">
                  <span class="data-row-left">
                    <h4 class="title table-title">VALET :</h4>
                    <a>
                        {{ transaction.expert?.user?.surname }} {{ transaction.expert?.user?.name }}
                    </a>
                  </span>
                </div> 
                -->

                <div class="item data-col-10" *ngIf="groupWhitelisted(['expert', 'admin', 'operation'])">
                  <span class="data-row-left">
                    <h4 class="title table-title">TOTALE:</h4>
                    <a>
                      {{ (transaction.totalAmount || 0) | currency: 'EUR' }}
                    </a>
                  </span>
                </div>                

                <div class="item nowrap">
                  <span class="data-row-left btn-container">
                  </span>
                </div>
            </div>
        </div>
    </div>
</section>